export default "__VITE_ASSET__DfRVowSw__"